import { mapGetters, mapState } from 'vuex';
import { editableMixin } from './EditableMixin';
export const renderMixin = {
         data() {
           return {
             loadingId: null,
             loadingParticipant: null,
             sortAlphabetical: true,
           };
         },
         mixins: [editableMixin],
         computed: {
           ...mapGetters([
             'isOwner',
             'userId',
             'isPremium',
             'isPollEditable',
             'getPollOptionValue',
             'isDeadlinePassed',
           ]),

           ...mapState({
             //             userId: (state) => state.Login.userId,  // I ass
             invitationId: (state) => state.invitationId,
             poll: (state) => state.poll.poll,
             participantBackup: (state) => state.poll.participantBackup,
           }),

           showSortIcons() {
             if (this.isOwner) {
               return true;
             }
             return !this.isHiddenPoll;
           },

           choiceConfig() {
             console.log('this.poll ==> ', this.poll);
             const choice_config = this.poll.choice_config;
             if (!choice_config) return [];
             return choice_config.additional_answers;
           },

           backgroundThumbnail() {
             if (this.$store.getters.bgImage) {
               let url = this.$store.getters.bgImage.url;
               return url;
             }
             return '/images/Orange by luke-chesser.jpg';
           },

           msgHiddenPoll() {
             return this.$t('options.hiddenPollParticipantTip', {
               pollType: this.polltype(this.poll.type),
               organizerName: this.poll.user_name,
             });
           },

           isRegularOwner() {
             return this.isOwner && !this.isPremium;
           },

           answersCount() {
             if (this.isHidden && !this.isOwner) {
               return 0;
             }
             // console.log("this.participantCount ==> ", this.participantCount)
             return this.participants.length;
           },

           commentsCount() {
             if (this.isHidden && !this.isOwner) {
               return 0;
             }
             return this.poll.comments.length;
           },

           deadlineDate() {
             if (!this.poll.deadline) return null;
             // let deadline = this.fullWeekDay(this.poll.deadline) + ' ';
             // deadline += this.dayMonthYear(this.poll.deadline);
             // return deadline;
             const locale = this.$i18n.locale;
             const options = {
               weekday: 'long',
               year: 'numeric',
               month: 'long',
               day: 'numeric',
               hour: 'numeric',
               minute: 'numeric',
             };
             return new Date(this.poll.deadline).toLocaleString(
               locale,
               options
             );
           },

           pollInfoMessage() {
             if (this.poll.closed) {
               let text = this.$t('close.status');
               if (this.poll.type == 2) {
                 text = this.$t('close.statusEvent');
               }
               return {
                 class: '',
                 icon: ['fas', 'info-circle'],
                 text: text,
               };
             }

             if (!this.poll.deadline) return null;
             if (this.isDeadlinePassed)
               return {
                 //class: 'bg-passed-deadline text-white',
                 class: '',
                 icon: ['fas', 'info-circle'],
                 text:
                   this.$t('close.statusPassedDeadline') +
                   this.deadlineDate +
                   ' (' +
                   this.$t('general.timeZone') +
                   ':' +
                   Intl.DateTimeFormat().resolvedOptions().timeZone +
                   ')',
               };

             return {
               class: '',
               icon: ['fas', 'info-circle'],
               text:
                 this.$t('close.statusDeadline') +
                 this.deadlineDate +
                 ' (' +
                 this.$t('general.timeZone') +
                 ':' +
                 Intl.DateTimeFormat().resolvedOptions().timeZone +
                 ')',
             };
           },

           responsesHeadline() {
             if (this.isHidden && !this.isOwner) {
               const headline = this.$t(
                 'polls.mobileHeadlineHiddenMode'
               ).replace('%d', this.poll.participants.length);
               return headline;
             }

             const headline = this.$t('polls.mobileHeadline').replace(
               '%d',
               this.poll.participants.length
             );
             return headline;
           },

           commentsHeadline() {
             if (this.isHidden) {
               if (this.isOwner) {
                 return this.$t('comments.headlineAdminHidden');
               }
               return this.$t('comments.headlineHidden').replace(
                 '%s',
                 this.poll.user.name
               );
             }
             if (this.isMobileView) {
               return null;
             }
             return this.$t('comments.headline');
           },

           showComments() {
             return this.getPollOptionValue('allowComments');
           },

           showTasks() {
             return this.getPollOptionValue('allowTasks');
           },

           isHidden() {
             return this.poll.options.hiddenPoll;
           },

           isBookingMode() {
             return this.poll.options.bookingModePoll;
           },

           isHiddenPoll() {
             return this.poll.options.hiddenPoll;
           },
           isClosedPoll() {
             return this.poll.closed;
           },

           isHiddenParticipantMode() {
             if (this.isOwner) return false;
             return this.poll.options.hiddenPoll;
           },

           limitedVotes() {
             return this.poll.options.limitedVotesPerChoice;
           },

           limitedChoieVotes() {
             return (
               this.poll.options.limitedVotesPerChoice ||
               this.poll.options.limitedVotesPerChoiceSpecific
             );
           },

           limitedVotesSpecific() {
             return this.poll.options.limitedVotesPerChoiceSpecific;
           },

           votesLimit() {
             return this.poll.options.votesLimit;
           },

           showCounts() {
             if (this.isOwner) return true;

             if (this.poll.options.hiddenPoll) {
               return this.poll.options.showCounts;
             }
             return true;
           },

           canSeeList() {
             if (!this.poll.options.hiddenPoll) return true;
             if (this.isOwner) return true;
             return true;
           },
           canPostComment() {
             if (!this.poll.options.hiddenPoll) return true;
             if (this.isOwner) return false;
             return true;
           },

           mayBeAnswersEnabled() {
             return this.poll.options.mayBeAnswers;
           },
           doNotKnowYetEnabled() {
             return this.poll.options.allowDoNotKnowAnswer;
           },
           isDateType() {
             return this.poll.type == 1;
           },
           isEventType() {
             return this.poll.type == 2;
           },

           participants() {
             if (this.isOwner) {
               return this.poll.participants;
             }

             if (!this.poll.options.hiddenPoll) {
               return this.poll.participants;
             }

             //  const invitationId = this.invitationId;
             //  let participants = this.poll.participants.filter((item) => {
             //    if (item.email  == this.curInvitation?.email)
             //      return item;
             //  });

             // out commented and replaced with filter for isCurrentUser
             // let participants = this.poll.participants;
             // if (participants.length == 0) {
             //   let userId = this.keyUserId;
             //   if (this.userId) userId = this.userId;
             //   participants = this.poll.participants.filter((item) => {
             //     if (item.isCurrentUser || (userId && item.user_id == userId))
             //       return item;
             //   });
             // }

             const participants = this.poll.participants.filter((item) => {
               if (item.isCurrentUser) return item;
             });
             return participants;
           },

           openInvitations() {
             if (this.isOwner) {
               return this.poll.invitations.filter(
                 (invitation) => invitation.participant_id == null
               );
             }
             return null;
           },

           invitesCount() {
             if (!this.openInvitations) return 0;
             return this.openInvitations.length;
           },

           options() {
             return this.poll.options;
           },
           freeTaskCout() {
             const nmbFreeTasks = 10;
             const freeTasks = nmbFreeTasks - this.poll.taskCount;
             if (freeTasks > 0) return freeTasks;
             return 0;
           },
         },
         filters: {
           email(text) {
             if (text == null) return ' ';
             return text;
           },

           timeRange(dateString) {
             const date = new Date(dateString);

             // console.log('date:', date);
             let hours = date.getHours();
             if (date.getHours() === 0 && date.getMinutes() === 0) {
               return '-';
             }
             hours = ('0' + hours).slice(-2);
             let minutes = date.getMinutes();
             minutes = ('0' + minutes).slice(-2);
             return hours + ':' + minutes;
           },

           month(dateString) {
             const date = new Date(dateString);
             const months = [
               'January',
               'February',
               'March',
               'April',
               'May',
               'June',
               'July',
               'August',
               'September',
               'October',
               'November',
               'December',
             ];
             let month = months[date.getMonth()];
             return month;
           },

           textComment(text) {
             if (!text) return '-';
             return text;
           },
           invitationsCount() {
             if (!this.openInvitations) return null;
             return this.openInvitations.length;
           },
         },

         methods: {
           participantList(submittingParticipant) {
             if (submittingParticipant) {
               return this.participants.filter(
                 (p) => p.id != submittingParticipant.id
               );
             }
             return this.participants;
           },

           visibleFormBorder(choice, submittingParticipant) {
             if (this.isBookingMode && !this.isOwner) {
               if (this.participantBackup) {
                 let preferenceForChoice = this.participantBackup.preference_list.find(
                   (preference) => preference.choice_id === choice.id
                 );
                 if (preferenceForChoice.value >= 0) return false;
               }
             }

             if (!this.isLimitReached(choice)) return true;
             const value = this.getAnswerForChoice(
               submittingParticipant,
               choice
             );
             if (value > 0) return true;
             return false;
           },
           isResponseEditable(participant) {
             if (!this.isBookingMode) return true;
             if (this.isOwner) return true;
             // check if all preference
             console.info('check responses:', participant.preference_list);
             for (const preference of participant.preference_list) {
               if (preference.value < 1) {
                 return true;
               }
             }
             return false;
           },

           showLimitCount(choice) {
             if (this.poll.options.limitedVotesPerChoice) {
               return true;
             }
             if (
               this.poll.options.limitedVotesPerChoiceSpecific &&
               choice.limit
             ) {
               return true;
             }
             return false;
           },


           showHelp() {
             // revert back when needs to open the answer info model
             // this.$refs.dlgHelpDialog.openModal(event);
           },

           hasUncompleteAttributes(participant) {
             // check if all mandatory attributes are fillout for the participant
             for (const attribute of this.poll.participant_attributes) {
               if (!attribute.mandatory) continue;
               const pa = participant.attributes.find(
                 (a) => a.name == attribute.name
               );
               if (!pa || pa.value.length == 0) return false;
             }
             return true;
           },

           goto(refName) {
             var element = this.$refs[refName];
             // var top = this.$refs['top'];
             var offset = element.offsetTop;
             console.log('Scroll to:', offset);
             //window.scroll(0, offset);
             element.scrollIntoView({
               behavior: 'smooth',
             });
           },
           polltype() {
             switch (this.poll.type) {
               case 1:
                 return this.$t('polls.typePoll');

               case 2:
                 return this.$t('polls.typeEvent');

               case 3:
                 return this.$t('polls.typeSurvey');

               default:
                 return this.$t('general.undefinedPoll');
             }
           },

           isInvited(participant) {
             if (!this.isOwner) return false;
             if (participant.invitation_id == null) return false;
             return true;
           },

           cssChoice(id) {
             if (this.poll.type === 1) return 'choice-text';
             return 'choice-text-survey choice-' + id;
           },

           dayMonth(dateString) {
             // const date = new Date(dateString);
             let dayMonth = null;
             const locale = this.$i18n.locale;
             if (dateString.start == dateString.end) {
               dayMonth = new Date(dateString.start).toLocaleDateString(
                 locale,
                 {
                   month: 'numeric',
                   day: 'numeric',
                   timeZone: this.poll.options.poll_timezone,
                 }
               );
             } else {
               let date = new Date(dateString.start);

               dayMonth = date.toLocaleDateString(locale, {
                 month: 'numeric',
                 day: 'numeric',
               });
             }
             return dayMonth;

             //  let day = date.getDate();
             //  day = ('0' + day).slice(-2);
             //  let month = date.getMonth() + 1;
             //  month = ('0' + month).slice(-2);
             //  return day + '.' + month;
           },

           dayMonthYear(dateString) {
             //const date = new Date(dateString.split(' ')[0]);
             const date = new Date(dateString);
             const locale = this.$i18n.locale;
             const dayMonth = date.toLocaleDateString(locale, {
               month: 'numeric',
               day: 'numeric',
               year: 'numeric',
             });
             return dayMonth;
             //  let day = date.getDate();
             //  day = ('0' + day).slice(-2);
             //  let month = date.getMonth() + 1;
             //  month = ('0' + month).slice(-2);
             //  return day + '.' + month;
           },

           weekDay(dateString) {
             let date;
             const locale = this.$i18n.locale;
             if (dateString.start == dateString.end) {
               date = new Date(dateString.start).toLocaleDateString(locale, {
                 weekday: 'short',
                 timeZone: this.poll.options.poll_timezone,
               });
             } else {
               date = new Date(dateString.start).toLocaleDateString(locale, {
                 weekday: 'short',
               });
             }
             return this.$t(`calender.${date.toLowerCase()}`);

             // ====== old code =====
             // const date = new Date(dateString);
             // const days = [
             //   'calender.su',
             //   'calender.mo',
             //   'calender.tu',
             //   'calender.we',
             //   'calender.th',
             //   'calender.fr',
             //   'calender.sa',
             // ];
             // let day = days[date.getDay()];
             // return this.$t(day);
           },

           fullWeekDay(dateString) {
             console.log('fullWeekDay', dateString);
             //const date = new Date(dateString.split(' ')[0]);
             const date = new Date(dateString);
             const days = [
               'calender.sunday',
               'calender.monday',
               'calender.tuesday',
               'calender.wednesday',
               'calender.thursday',
               'calender.friday',
               'calender.saturday',
             ];
             let day = days[date.getDay()];
             return this.$t(day);
           },

           isLoading(participant, id) {
             if (this.$store.state.loadingId != id) {
               return false;
             }
             if (this.$store.state.loadingParticipant != participant) {
               return false;
             }
             console.log('Loading check true:', id);
             return true;
           },

           // toggle sequence  no answer -> 1 -> 2 -> 0 -> -2 -> 1 ....
           getNextAnswerValue(value) {
             switch (value) {
               case -2:
                 return 1;
               case -1:
                 return 1;
               case 0:
                 return -2;
               case 2:
                 return 0;
               case 1:
                 if (this.mayBeAnswersEnabled) {
                   return 2;
                 }
                 return 0;
             }
           },

           isAnswerCompleted(participant) {
             for (let i = 0; i < participant.preference_list.length; i++) {
               if (participant.preference_list[i].value === -1) {
                 return false;
               }
             }
             return true;
           },

           isAnyAnswerGiven(participant) {
             for (let i = 0; i < participant.preference_list.length; i++) {
               if (participant.preference_list[i].value != -1) {
                 return true;
               }
             }
             return false;
           },
           isAnswerEmpty(participant) {
             for (let i = 0; i < participant.preference_list.length; i++) {
               if (participant.preference_list[i].value !== -1) {
                 return false;
               }
             }
             return true;
           },
           getEditableTooltip(participant) {
             return this.isEditable(participant)
               ? this.$t('polls.clickToEditName')
               : '';
           },

           isEmailVisible(participant) {
             if (this.isOwner) {
               return true;
             }

             if (this.userId && this.userId == participant.user_id) {
               console.log(
                 'this.userId == participant.user_id -->',
                 this.userId == participant.user_id
               );
               return true;
             }
             if (
               this.curInvitation &&
               this.curInvitation.participant_id == participant.id
             ) {
               console.log(
                 'this.curInvitation.participant_id == participant.id -->',
                 this.curInvitation.participant_id == participant.id
               );
               return true;
             }
             return false;
           },

           getEditableClass(participant) {
             let classes = '';
             if (this.isEditable(participant)) {
               classes = ' editable';
             }
             return classes;
           },

           getAnswerForChoice(participant, choice) {
             var choiceId = choice.id;
             if (participant && choiceId && participant.preference_list) {
               let preferenceForChoice = participant.preference_list.find(
                 (preference) => preference.choice_id === choiceId
               );

               if (preferenceForChoice) {
                 return preferenceForChoice.value;
               } else {
                 // FIXME:
               }
             }
             return -1;
           },

           renderChoiceAnswer(index, answer) {
             if (answer.value === null || answer.value === '') return '--';

             const choice_config = this.poll.choice_config;
             console.info('renderChoiceAnswer', answer, index, choice_config);
             const answerCfg = choice_config.additional_answers[index];
             const value = answerCfg.values[answer.value].value;
             return value;
           },

           getPreferenceAnswer(participant, choice, index) {
             const preference = this.getPreferenceForChoice(
               participant,
               choice
             );

             if (!preference || !preference.answers) {
               console.error(
                 'No preference was found for',
                 participant,
                 choice.id
               );
               return null;
             }
             console.error('getPreferenceAnswer', preference, index);
             // return preference.answers.values[index].value;
             return preference.answers[index].value;
           },

           getPreferenceAnswerValueForDisplay(participant, choice, index) {
             const preference = this.getPreferenceForChoice(
               participant,
               choice.id
             );

             if (!preference) {
               console.error(
                 'No preference was found for',
                 participant,
                 choice.id
               );
               return null;
             } else if (!preference.answers) {
               return '-';
             }

             console.error('getPreferenceValueAnswer', preference, index);
             // return preference.answers.values[index].value;
             const answer = preference.answers[index];
             if (answer.value === null || answer.value === '') return '-';

             const choice_config = this.poll.choice_config;
             const answerCfg = choice_config.additional_answers[index];
             const value = answerCfg.values[answer.value].value;
             return value;
           },

           onSetTime(time, participant, choiceId, index) {
             console.info(
               'On set time',
               time,
               participant.name,
               choiceId,
               index
             );
             const preference = this.getPreferenceForChoice(
               participant,
               choiceId
             );
             // preference.answers.values[index].value = time;
             preference.answers[index].value = time;
           },

           onSelectOptions(id, participant, choiceId, index) {
             const preference = this.getPreferenceForChoice(
               participant,
               choiceId
             );
             console.info(
               'onSelectOptions preference.answers ==> ',
               preference.answers
             );
             if (preference.answers == null) {
               preference.answers = [];
               console.info(
                 'On select options:init answers ',
                 this.choiceConfig
               );
               for (let i = 0; i < this.choiceConfig.length; i++) {
                 const answer = { type: 'select', value: null };
                 preference.answers.push(answer);
               }
               console.info('On select options:  answers ', preference, index);
             }
             preference.answers[index].value = id;
           },

           getPreferenceForChoice(participant, choiceId) {
             if (participant && choiceId && participant.preference_list) {
               let preferenceForChoice = participant.preference_list.find(
                 (preference) => preference.choice_id === choiceId
               );

               if (preferenceForChoice) {
                 return preferenceForChoice;
               } else {
                 // FIXME:
               }
             }
             return null;
           },

           isChoiceVotesLimitReached(value, choice) {
             var choiceId = choice.id;
             if (
               !(
                 this.options.limitedVotesPerChoice ||
                 this.options.limitedVotesPerChoiceSpecific
               )
             )
               return false;

             if (value > 0) return false;
             let limit = this.options.votesLimit;
             if (this.options.limitedVotesPerChoiceSpecific) {
               if (choice.limit == 0 || choice.limit == null) return false;
               limit = choice.limit;
             }
             let votesCount = 0;
             for (const p of this.poll.participants) {
               for (const preference of p.preference_list) {
                 if (preference.value > 0 && preference.choice_id == choiceId)
                   votesCount = votesCount + 1;
               }
             }
             return votesCount >= limit;
           },

           isDisabled(participant, choice) {
             const value = this.getAnswerForChoice(participant, choice);
             return this.isChoiceVotesLimitReached(value, choice);
           },

           removeSelectionsForSingleOptionMode(
             participant,
             value,
             ignoreChoiceId
           ) {
             if (this.options.oneChoicePerParticipant == false) return;
             if (value > 0) return; // no impact on oher choices
             //  decline all participant preferences
             for (const preference of participant.preference_list) {
               // change the value and update the backend
               console.log(
                 'removeSelectionsForSingleOptionMode preference:',
                 preference.choice_id,
                 ignoreChoiceId
               );
               if (preference.choice_id === ignoreChoiceId) continue; // if in TBD status
               if (preference.value <= 0) continue; // if in TBD status
               let data = {};
               data.choice_id = preference.choice_id;
               data.value = 0;
               data.participant = participant;
               this.$store.dispatch('updateChoice', data);
               preference.value = 0;
             }
           },

           toggleChoice(event, participant, choice) {
             var choiceId = choice.id;
             if (!this.isPollEditable) {
               console.log('this poll is not editable');
               return;
             }
             if (this.isEditable(participant) == false) {
               console.log('this choice is not editable');
               return;
             }

             if (this.loadingId) {
               return;
             }

             console.log(
               'Toggle choice from preference list:',
               event.clientX,
               event.clientY,
               choiceId,
               participant.preference_list
             );

             let preferenceForChoice = participant.preference_list.find(
               (preference) => preference.choice_id === choiceId
             );

             let orgPreferenceForChoice = this.participantBackup.preference_list.find(
               (preference) => preference.choice_id === choiceId
             );
             console.info('Preferece value:', orgPreferenceForChoice.value);
             if (this.isBookingMode && !this.isOwner) {
               console.info('Booking mode:', preferenceForChoice);
               if (orgPreferenceForChoice.value >= 0) {
                 console.info('Preferece is already set and booking mode');
                 return;
               }
             }

             if (preferenceForChoice) {
               const editedChoice = {
                 participant,
                 choiceId,
                 posX: event.clientX,
                 posY: event.clientY,
               };

               console.log('event editedChoice:', editedChoice);
               this.$emit('editedChoice', editedChoice);
               this.editedChoice = editedChoice;

               this.dglPreferenceForChoice = preferenceForChoice;

               console.log(
                 'toggleChoice:',
                 preferenceForChoice.choice_id,
                 choiceId
               );

               const dialogMode = true;
               if (dialogMode) {
                 this.dlgChoiceDialog.openModal(event);
                 return;
               }

               let value = preferenceForChoice.value;

               if (this.isChoiceVotesLimitReached(value, choice)) {
                 console.log('votes limit was reached');
                 return;
               }
               //this.removeSelectionsForSingleOptionMode(participant, value, choiceId);

               value = this.getNextAnswerValue(value);
               //preferenceForChoice.value = value;
               let data = {};
               data.choice_id = choiceId;
               data.value = value;
               data.participant = participant;
               //this.loadingId = choiceId;
               this.loadingParticipant = participant;
               console.log('toggle:', data);
               data.oneChoicePerParticipant = this.options.oneChoicePerParticipant;
               this.$store.commit('updateParticipantChoice', data);
               // this.$store
               //   .dispatch('updateChoice', data)
               //   .then(() => {
               //     setTimeout(() => {
               //       this.loadingId = null;
               //       this.loadingParticipant = null;
               //       this.$emit('whenUpdateChoice');
               //     }, 200);
               //   })
               //   .catch((error) => console.log(error));
             } else {
               console.error(
                 'toggleChoice - choice not found by id:',
                 choiceId,
                 participant,
                 participant.preference_list
               );
               // TODO: - notify error service
               // FIXME:
             }
           },

           onSelectChoice(value) {
             this.selectChoice(value, this.editedChoice);
           },

           selectChoice(value, editedChoice) {
             console.log(
               'Choice selected:',
               value,
               editedChoice.participant,
               editedChoice.choiceId
             );
             this.$refs.dlgChoiceDialog.closeModal();
             let data = {};
             data.choice_id = editedChoice.choiceId;
             data.value = value;
             data.participant = editedChoice.participant;

             const loadingId = editedChoice.choiceId;
             const loadingParticipant = editedChoice.participant;
             // this.$store.commit('setLoading', {
             //   loadingId,
             //   loadingParticipant,
             // });
             console.log('Loading is on:', loadingId, loadingParticipant);
             console.log('toggle:', data);
             data.oneChoicePerParticipant = this.options.oneChoicePerParticipant;

             console.log('toggle:', data);
             data.oneChoicePerParticipant = this.options.oneChoicePerParticipant;

             const fronEndOnly = true;
             if (fronEndOnly) {
               this.$store.commit('updateParticipantChoice', data);
             } else {
               this.$store
                 .dispatch('updateChoice', data)
                 .then(() => {
                   setTimeout(() => {
                     const loadingId = null;
                     const loadingParticipant = null;
                     this.$store.commit('setLoading', {
                       loadingId,
                       loadingParticipant,
                     });
                     this.$emit('whenUpdateChoice');
                   }, 1);
                 })
                 .catch((error) => console.log(error));
             }
           },

           countYesAnswers(choice) {
             let sum = 0;
             for (var i = 0; i < this.poll.participants.length; i++) {
               if (
                 this.getAnswerForChoice(this.poll.participants[i], choice) > 0
               )
                 sum++;
             }
             return sum;
           },
           getAllParticipantOfChoice(choiceId) {
             let usersData = [];
             for (var i = 0; i < this.poll.participants.length; i++) {
               let participant = this.poll.participants[i];
               if (participant && choiceId && participant.preference_list) {
                 let preferenceForChoice = participant.preference_list.find(
                   (preference) => preference.choice_id === choiceId
                 );
                 usersData.push({
                   name: this.poll.participants[i].name,
                   email: this.poll.participants[i].user?.email,
                   choice: preferenceForChoice.value,
                 });
               }
             }
             return usersData;
           },
           countNoAnswers(choice) {
             let sum = 0;
             for (var i = 0; i < this.poll.participants.length; i++) {
               if (
                 this.getAnswerForChoice(this.poll.participants[i], choice) ===
                 0
               )
                 sum++;
             }
             return sum;
           },

           getCssOfAnswer(participant, choice) {
             let response = this.getAnswerForChoice(participant, choice);
             if (response == -1) return 'text-primary';
             return null;
           },
           getDescriptionOfAnswer(participant, choice) {
             let response = this.getAnswerForChoice(participant, choice);
             switch (response) {
               case 1:
                 return this.$t('general.yes');
               case 2:
                 return this.$t('general.maybe');
               // merge conflict
               // case -2:
               //   return this.$t('general.notSureYet');
               case 0:
                 return this.$t('general.no');
               case -2:
                 return this.$t('general.dontknow');
               case -1:
                 // return this.$t('general.selectAnswer');
                 return null;
             }
           },
           reloadBrowser() {
             window.location.reload();
           },
           createLimitErrorString(response) {
             let choiceUpdateErrorHTML = '<ul>';
             for (let i = 0; i < this.poll.choices.length; i++) {
               for (let j = 0; j < response.data.error.length; j++) {
                 if (this.poll.choices[i].id == response.data.error[j]) {
                   if (this.poll.type == 3) {
                     choiceUpdateErrorHTML +=
                       '<li>' + this.poll.choices[i].text + '</li>';
                   } else {
                     choiceUpdateErrorHTML +=
                       '<li>' +
                       this.dayMonth({
                         start: this.poll.choices[i].start,
                         end: this.poll.choices[i].end,
                       });

                     if (
                       this.poll.choices[i].start != this.poll.choices[i].end
                     ) {
                       let start = this.$options.filters.timeRange(
                         this.poll.choices[i].start
                       );
                       let end = this.$options.filters.timeRange(
                         this.poll.choices[i].end
                       );
                       if (start != '-' && end != '-') {
                         choiceUpdateErrorHTML += ' : ';
                         if (start != '-') {
                           choiceUpdateErrorHTML += start;
                         }
                         if (end != '-') {
                           choiceUpdateErrorHTML += ' - ' + end;
                         }
                       }
                     }
                     choiceUpdateErrorHTML += '</li>';
                   }
                   break;
                 }
               }
             }
             return (
               this.$t('options.partialAnswerError') +
               '<br/>' +
               choiceUpdateErrorHTML
             );
           },
           getSelectOptionsFromConfig(participant, choice) {
             let answer = this.getAnswerForChoice(participant, choice);
             let configAnswers = this.choiceConfig;
             for (let i = 0; i < configAnswers.length; i++) {
               if (
                 configAnswers[i].main_answer.code ==
                 this.getCodeNameFromChoiceAnswer(answer)
               ) {
                 return configAnswers[i].values.map((option) => option.value);
               }
             }
             return [];
           },
           getSelectLabelFromConfig(participant, choice) {
             let answer = this.getAnswerForChoice(participant, choice);
             let configAnswers = this.choiceConfig;
             for (let i = 0; i < configAnswers.length; i++) {
               if (
                 configAnswers[i].main_answer.code ==
                 this.getCodeNameFromChoiceAnswer(answer)
               ) {
                 return configAnswers[i].labelValue;
               }
             }
             return null;
           },
           getCodeNameFromChoiceAnswer(answer) {
             if (answer == 0) {
               return 'main_answer_is_no';
             } else if (answer >= 1) {
               return 'main_answer_is_yes';
             } else {
               return 'always';
             }
           },

           isParticipantAllowedToSetTheAnswer(answer) {
             const who_can_answer = answer.who_can_answer.code;
             console.info(
               'check answer permission for user. is admin:',
               this.isOwner
             );
             if (who_can_answer == 'admin' && this.isOwner != false) {
               return true;
             } else if (who_can_answer == 'user' && this.isOwner == false) {
               return true;
             } else if (who_can_answer == 'both') {
               return true;
             }
             return false;
           },
           findAllWhichMatchesChoiceAnswer(participant, choice) {
             let answer = this.getAnswerForChoice(participant, choice);
             let configAnswers = [];
             for (let i = 0; i < this.choiceConfig.length; i++) {
               // If only ADMIN can answer then user will see the answer of ADMIN with only view mode, so isReadonly wil updated and used for view mode only
               if (
                 this.choiceConfig[i].who_can_answer.code == 'admin' &&
                 this.isAdmin == false
               ) {
                 if (
                   this.choiceConfig[i].main_answer.code ==
                   this.getCodeNameFromChoiceAnswer(answer)
                 ) {
                   configAnswers.push({
                     config: this.choiceConfig[i],
                     isReadonly: true,
                   });
                 }
               } else if (
                 this.choiceConfig[i].main_answer.code ==
                 this.getCodeNameFromChoiceAnswer(answer)
               ) {
                 configAnswers.push({
                   config: this.choiceConfig[i],
                   isReadonly: false,
                 });
               }
             }
             return configAnswers;
           },
           getAdminAnswerWhenUserIsNotAllowed(config, choice, index) {
             for (let i = 0; i < this.participants.length; i++) {
               // find the admin and display the admin answer to the user
               if (this.participants[i].user_id == this.poll.user_id) {
                 return this.getPreferenceAnswerValueForDisplay(
                   this.participants[i],
                   choice,
                   index
                 );
               }
             }
             return '-';
           },
         },
       };
